import * as React from "react"
import Svg, { Circle, G, Path, Defs, ClipPath } from "react-native-svg"

function PersonalLoanSvg(props) {
  return (
    <Svg
      width={props.width}
      height={props.height}
      viewBox="0 0 68 67"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle
        cx={34.0244}
        cy={33.1521}
        r={33.1521}
        fill="#F2F2FF"
        fillOpacity={0.55}
      />
      <G clipPath="url(#clip0_120_1197)">
        <Path
          d="M33.953 46.665h-.007a.537.537 0 11.007 0zm2.128-.164a.537.537 0 01-.093-1.065l.022-.004a.537.537 0 11.074 1.07h-.003zm.02-.46v.007l-.013-.085.013.078zm-4.282.438a.537.537 0 11.072-1.068h.023a.536.536 0 01-.095 1.064v.004zm-.015-.457v.006l.015-.086-.015.08zm6.359-.032a.54.54 0 11.181-.032l-.009.004a.537.537 0 01-.17.027h-.002zm-8.419-.048a.537.537 0 01-.175-.03l-.018-.005a.538.538 0 11.193.035zm10.387-.801a.536.536 0 01-.257-1.009l.01-.005a.538.538 0 11.51.947l-.255-.471.25.475a.54.54 0 01-.256.063h-.002zm-12.346-.072a.532.532 0 01-.251-.063l-.022-.012a.536.536 0 11.273.072v.003zm14.145-1.09a.543.543 0 11.335-.117l-.012.008a.536.536 0 01-.32.11h-.003zM26 43.887a.532.532 0 01-.332-.117l.334-.42-.336.419a.537.537 0 11.668-.84.537.537 0 01-.333.958zm17.517-1.35a.539.539 0 11.399-.179l-.009.01a.535.535 0 01-.39.168zm-19.089-.11a.53.53 0 01-.391-.172l-.009-.01a.533.533 0 11.4.181zm20.415-1.575a.53.53 0 01-.438-.23.537.537 0 01-.013-.596l.013-.019a.537.537 0 11.44.845h-.002zm.071-.496l.006.003-.072-.05.066.047zm-21.793.372a.536.536 0 01-.447-.24l-.012-.02a.537.537 0 11.459.26zm22.755-1.753a.537.537 0 01-.485-.763.537.537 0 11.978.443l-.49-.221.49.222a.54.54 0 01-.493.32zm-23.767-.134a.533.533 0 01-.489-.322l-.005-.012a.535.535 0 11.494.332v.002zm24.476-1.887a.538.538 0 11.522-.41v.007a.536.536 0 01-.52.403h-.002zm-25.156-.14a.537.537 0 01-.52-.411l.52-.127-.522.125a.537.537 0 011.04-.265v.014a.537.537 0 01-.518.663zm25.524-1.97h-.048a.538.538 0 11.583-.495v.007a.535.535 0 01-.536.487h.001zM21.09 34.7a.537.537 0 01-.535-.497l.535-.04-.535.038a.538.538 0 111.073-.091v.014a.537.537 0 01-.54.573l.002.003zm25.874-1.999a.534.534 0 01-.533-.487v-.015-.027a.538.538 0 111.074-.068v.015a.538.538 0 01-.491.578l-.05.004zm-25.867-.15h-.046a.535.535 0 01-.488-.578v-.008a.537.537 0 11.534.588v-.002zm25.524-1.994a.535.535 0 01-.517-.4l-.004-.015a.536.536 0 111.043-.253l-.522.126.522-.125a.54.54 0 01-.522.667zm-25.163-.118a.533.533 0 01-.519-.667v-.006a.536.536 0 11.518.673h.001zm24.476-1.91a.538.538 0 11.488-.758l.006.013a.536.536 0 01-.494.745zm-23.769-.11a.529.529 0 01-.391-.17.537.537 0 01-.098-.587l.49.22-.489-.222a.537.537 0 01.978.443.538.538 0 01-.49.316zm22.758-1.778a.54.54 0 11.443-.839l.009.014a.537.537 0 01-.45.824h-.002zm-21.73-.101a.542.542 0 11.458-.254c0 .004-.01.015-.012.019a.537.537 0 01-.444.235h-.002zm20.423-1.595a.538.538 0 11.39-.905l.008.01a.538.538 0 01-.398.895zM24.52 24.85a.535.535 0 01-.396-.896l.009-.01a.537.537 0 11.387.906zm17.52-1.36a.537.537 0 01-.328-.112l-.01-.008a.537.537 0 11.667-.841l-.329.417.336-.42a.538.538 0 01-.336.965zm-15.94-.075a.537.537 0 01-.33-.96l.012-.01a.536.536 0 11.32.966l-.003.004zm14.153-1.106a.537.537 0 01-.418-.882.539.539 0 01.665-.132l.022.012a.537.537 0 01-.269 1.002zm-12.356-.06a.537.537 0 01-.252-1.01l.252.474-.25-.475a.537.537 0 11.252 1.008l-.002.004zm10.399-.812a.526.526 0 01-.186-.033.537.537 0 11.354-1.014l.018.007a.536.536 0 01-.186 1.04zm-8.422-.045a.538.538 0 01-.36-.937.534.534 0 01.18-.105l.009-.003a.536.536 0 11.17 1.045zm6.352-.495a.48.48 0 01-.08-.006l-.022-.003a.539.539 0 11.102.009zm-4.279-.017a.542.542 0 11.103-.01h-.023a.6.6 0 01-.083.01h.003zm2.144-.168a.54.54 0 01-.385-.915.534.534 0 01.378-.158h.007a.537.537 0 010 1.073zm3.352 15.138l-6.828-.437-.644-2.956c-.41-1.897.912-3.731 2.707-3.721h.042c.658.008 1.104.13 1.824.286.367.08.791.168 1.27.255 1.59.286 2.626 1.976 2.257 3.68-.173.82-.45 2.075-.628 2.893z"
          fill="#57565C"
        />
        <Path
          d="M35.818 29.28c-.48-.087-.904-.175-1.271-.255-.72-.159-1.166-.28-1.824-.287h-.042c-.154 0-.308.013-.46.04.394.05.758.143 1.252.249.368.08.792.168 1.272.255 1.59.286 2.625 1.975 2.256 3.68l-.531 2.454.973.437c.177-.818.455-2.076.631-2.89.37-1.708-.666-3.395-2.256-3.684z"
          fill="#3C3B41"
        />
        <Path
          d="M43.706 47.042v4.431H24.343v-4.432a3.515 3.515 0 012.49-3.364l1.66-.505.048-.016 1.883-.572a1.756 1.756 0 001.244-1.68l.21-1.679c.109-.329.439-1.174 1.303-1.762.358-.246 1.254-.854 2.083-.494.723.313 1.162 1.258 1.03 2.311.02.661.034 1.193.041 1.611a1.758 1.758 0 00.417 1.139l.026.03c.215.241.492.42.802.514l1.885.572.058.018 1.695.516a3.515 3.515 0 012.488 3.362z"
          fill="#548A3E"
        />
        <Path
          d="M41.215 43.68l-1.695-.516-.058-.017-1.885-.573a1.754 1.754 0 01-.801-.514l-.026-.03a1.758 1.758 0 01-.417-1.139c-.008-.418-.023-.95-.043-1.61.133-1.054-.306-1.999-1.029-2.312-.376-.163-.766-.127-1.113-.016l.04.016c.722.313 1.162 1.258 1.029 2.312.02.66.035 1.192.042 1.61a1.758 1.758 0 00.417 1.139l.026.03c.215.242.492.42.802.514l1.885.573.058.017 1.695.516a3.515 3.515 0 012.49 3.364v4.43h1.074v-4.431a3.515 3.515 0 00-2.49-3.363z"
          fill="#548A3E"
        />
        <Path
          d="M36.75 42.026l-2.748 1.79-2.748-1.777c.268-.316.415-.718.415-1.133l.071-.577.138-1.104c.11-.329.439-1.174 1.303-1.762.358-.246 1.254-.854 2.083-.494.723.313 1.162 1.258 1.03 2.311l.029 1.037.013.572a1.757 1.757 0 00.414 1.137z"
          fill="#FDD8AE"
        />
        <Path
          d="M36.32 40.317c-.606.787-1.411 1.352-2.294 1.352-.884 0-1.682-.562-2.287-1.342l.138-1.102c.11-.329.44-1.174 1.304-1.762.358-.246 1.253-.854 2.083-.494.722.313 1.162 1.258 1.029 2.311.008.39.021.734.026 1.037z"
          fill="#FBBF7D"
        />
        <Path
          d="M37.436 36.247c0 1.772-1.527 4.348-3.411 4.348-1.885 0-3.41-2.576-3.41-4.348V34.98c-.05-.674.104-1.104.397-1.35.573-.481 1.346 0 2.045-.493.684-.486 1.25-.65 1.964-.153.761.53 1.469.133 2.018.644.215.201.446.58.397 1.35v1.27z"
          fill="#FDD8AE"
        />
        <Path
          d="M37.039 33.628c-.55-.512-1.257-.116-2.018-.644-.506-.352-.937-.37-1.389-.18.11.05.216.11.315.18.762.53 1.47.134 2.018.644.215.202.446.58.397 1.351v1.268c0 1.597-1.245 3.856-2.873 4.279.175.046.356.07.537.071 1.883 0 3.41-2.58 3.41-4.348v-1.27c.049-.771-.18-1.15-.397-1.351z"
          fill="#FBBF7D"
        />
        <Path
          d="M33.964 43.732l-2.453 1.974a.627.627 0 01-.866-.076l-2.152-2.459.048-.015 1.883-.572a1.74 1.74 0 00.83-.547l2.71 1.695zm5.556-.568l-2.178 2.466a.627.627 0 01-.865.076l-2.452-1.974 2.75-1.675c.215.242.493.42.802.515l1.885.572.058.02z"
          fill="#548A3E"
        />
        <Path
          d="M34.561 44.268v7.205h-1.073v-7.205a.537.537 0 011.073 0z"
          fill="#548A3E"
        />
        <Path
          d="M46.423 38.538a5.385 5.385 0 113.808-1.575 5.351 5.351 0 01-3.808 1.575z"
          fill="#2C3AD9"
        />
        <Path
          d="M50.231 29.344a5.35 5.35 0 00-3.808-1.574c-.3 0-.599.025-.894.075a5.384 5.384 0 010 10.62 5.386 5.386 0 004.703-9.118v-.003z"
          fill="#2C3AD9"
        />
        <Path
          d="M46.423 39.074a5.923 5.923 0 114.188-1.734 5.884 5.884 0 01-4.188 1.734zm0-10.77a4.85 4.85 0 103.43 1.42 4.815 4.815 0 00-3.43-1.42z"
          fill="#2C3AD9"
        />
        <Path
          d="M45.833 34.182h-1.354a.536.536 0 110-1.073h1.354a1.127 1.127 0 000-2.254h-.972a.537.537 0 110-1.073h.972a2.2 2.2 0 010 4.4z"
          fill="#fff"
        />
        <Path
          d="M48.41 30.855h-3.931a.537.537 0 110-1.073h3.93a.537.537 0 010 1.073zm0 1.637h-3.931a.537.537 0 110-1.073h3.93a.537.537 0 110 1.073zm-.977 4.58a.536.536 0 01-.375-.152l-2.976-2.892a.537.537 0 11.75-.77l2.976 2.892a.537.537 0 01-.374.922h-.002z"
          fill="#fff"
        />
        <Path
          d="M34.025 26.139A5.385 5.385 0 1139 18.694a5.387 5.387 0 01-2.915 7.039 5.35 5.35 0 01-2.061.405z"
          fill="#2C3AD9"
        />
        <Path
          d="M37.832 16.945a5.35 5.35 0 00-3.808-1.577c-.3 0-.599.025-.894.075a5.385 5.385 0 012.913 9.121 5.346 5.346 0 01-2.913 1.503c.295.048.595.072.894.072a5.384 5.384 0 003.808-9.194z"
          fill="#2C3AD9"
        />
        <Path
          d="M34.025 26.675a5.922 5.922 0 01-4.188-10.109 5.923 5.923 0 118.374 8.373 5.885 5.885 0 01-4.186 1.736zm0-10.77a4.848 4.848 0 103.428 1.42 4.819 4.819 0 00-3.428-1.42z"
          fill="#2C3AD9"
        />
        <Path
          d="M33.433 21.783H32.08a.537.537 0 010-1.073h1.354a1.127 1.127 0 000-2.254h-.972a.537.537 0 010-1.073h.972a2.2 2.2 0 010 4.4z"
          fill="#fff"
        />
        <Path
          d="M36.007 18.456h-3.928a.537.537 0 010-1.073h3.928a.536.536 0 110 1.073zm0 1.636h-3.928a.537.537 0 010-1.073h3.928a.536.536 0 110 1.073zm-.973 4.58a.537.537 0 01-.375-.151l-2.977-2.891a.537.537 0 11.749-.77l2.976 2.892a.537.537 0 01-.373.922v-.002z"
          fill="#fff"
        />
        <Path
          d="M21.626 38.538a5.385 5.385 0 113.807-1.575 5.349 5.349 0 01-3.807 1.575z"
          fill="#2C3AD9"
        />
        <Path
          d="M25.437 29.344a5.352 5.352 0 00-4.702-1.5 5.386 5.386 0 010 10.621 5.385 5.385 0 004.702-9.121z"
          fill="#2C3AD9"
        />
        <Path
          d="M21.626 39.074a5.921 5.921 0 114.187-1.734 5.882 5.882 0 01-4.187 1.734zm0-10.77a4.85 4.85 0 103.428 1.42 4.819 4.819 0 00-3.428-1.42z"
          fill="#2C3AD9"
        />
        <Path
          d="M21.035 34.182H19.68a.537.537 0 110-1.073h1.354a1.127 1.127 0 000-2.254h-.973a.537.537 0 110-1.073h.973a2.2 2.2 0 010 4.4z"
          fill="#fff"
        />
        <Path
          d="M23.608 30.855H19.68a.536.536 0 110-1.073h3.927a.537.537 0 010 1.073zm0 1.637H19.68a.536.536 0 110-1.073h3.927a.537.537 0 110 1.073zm-.974 4.58a.533.533 0 01-.373-.152l-2.979-2.892a.537.537 0 01.748-.77l2.977 2.892a.537.537 0 01-.374.922h.001z"
          fill="#fff"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_120_1197">
          <Path
            fill="#fff"
            transform="translate(15.704 14.831)"
            d="M0 0H36.6418V36.6418H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default PersonalLoanSvg
